"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var transformFilename = function transformFilename(a) {
  var b = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : 15;
  if ("string" != typeof a) return "";
  var c = a.match(/(?:\.([^.]+))?$/)[0].toString(),
      d = a.split(c)[0];
  return d.length > b ? "".concat(d.substr(0, b), "...").concat(d.substring(b - 3, b)).concat(c) : "".concat(d).concat(c);
},
    _default = transformFilename;

exports["default"] = _default;